'use client';

import { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';

const menuItemIds = ['about-us', 'getting-started', 'faq'] as const;

export default function AboutMenu() {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('about-us');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'about-us';
      setActiveSection(hash);
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const menuItems = menuItemIds.map((id) => ({
    id,
    label: t(`aboutPage.menu.${id === 'about-us' ? 'aboutUs' : id === 'getting-started' ? 'gettingStarted' : 'faq'}`),
  }));

  return (
    <>
      <Sidebar.Header title={t('aboutPage.menu.title')} hideSearch={true} />
      <Sidebar.Content>
        <Sidebar.MenuSection>
          {menuItems.map((item) => (
            <Sidebar.MenuItem
              key={item.id}
              label={item.label}
              href={`#${item.id}`}
              active={activeSection === item.id}
              testId={`about-menu-${item.id}`}
            />
          ))}
        </Sidebar.MenuSection>
      </Sidebar.Content>
    </>
  );
}
